import { ScreenName } from '@helpcenter/constants';
import { CsmUserProfile } from 'view/user-profile/csm-variants';
import { createRouteWithLayout } from '@atlassian/help-center-common-util/resource-router';

const viewUserProfilePage = {
    name: 'user-profile',
    path: '/user/profile',
    exact: true,
    resources: [],
    component: CsmUserProfile,
};

export const csmUserProfileRoute = createRouteWithLayout(viewUserProfilePage, ScreenName.USER_PROFILE, {
    hideSearchButton: false,
    paperAppearance: 'normal',
    fadeInSearchModal: true,
});
